export default __webpack_public_path__ + "static/media/cp_geo_mr.22da2dfa.svg";